import type { Product, StationSettings } from './domain';

export const stationHours: StationSettings['openingHours'] = Array.from({ length: 7 }, (_, day) => ({ day, open: '09:00', close: '17:00', closed: day === 0 || day === 6 }));

/** Read-through compatibility for the original saved starter schedule. No writes,
 * no pause changes, and deliberate custom schedules remain authoritative. */
export function customerHours(hours: StationSettings['openingHours']) {
  const legacy = hours.length === 7 && new Set(hours.map(h => h.day)).size === 7 && hours.every(h => h.day >= 0 && h.day <= 6 && h.open === '08:00' && h.close === '17:00' && h.closed === (h.day === 0 || h.day === 6));
  return legacy ? stationHours : hours;
}

/** Less Ice uses a saved quantity when present, otherwise 60% of Normal Ice.
 * Only recipes with an explicit ice component and a valid normal choice qualify.
 * Never infer a temperature or change the original/default recipe. */
export function customerIce(product: Product): Product {
  const normal = product.iceQuantities.normal;
  if (!product.iceLevels.includes('normal') || product.iceLevels.includes('less') || !product.ingredients.some(i => i.role === 'ice') || !Number.isFinite(normal) || normal! <= 0) return product;
  const less = product.iceQuantities.less ?? Math.round(normal! * 0.6 * 1e6) / 1e6;
  if (!Number.isFinite(less) || less <= 0 || less >= normal!) return product;
  return { ...product, iceLevels: [...product.iceLevels, 'less'], iceQuantities: { ...product.iceQuantities, less } };
}

// Menu names are recognized, not recipe IDs: saved catalogs may use their own IDs.
// Do not reinterpret other recipes (e.g. Vietnamese condensed milk) as espresso.
export function customerDrinkKey(name: string): string | undefined {
  const key = name.trim().replace(/\s*[—–-]\s*(Hot|Iced)$/i, '').replace(/^B16\s+/i, '').toLowerCase();
  return ({ americano: 'americano', 'fresh latte': 'freshLatte', 'caffè latte': 'freshLatte', 'spanish latte': 'spanishLatte', 'aren latte': 'arenLatte', 'kopi susu aren': 'arenLatte', 'creamy aren': 'creamyAren', 'white coffee': 'whiteCoffee' } as Record<string, string>)[key];
}

export function customerCategory(category: string) {
  return ['espresso', 'coffee', 'kopi'].includes(category.toLowerCase()) ? 'Coffee' : category;
}
